import React from "react";

// ---- Device frames -------------------------------------------------
export const DesktopFrame = ({ children, url = "equiwelt.com", testid }) => (
  <div data-testid={testid} className="rounded-md border border-[#E8E4DB] bg-white shadow-[0_20px_60px_-30px_rgba(23,58,44,0.45)] overflow-hidden">
    <div className="flex items-center gap-2 border-b border-[#E8E4DB] bg-[#F4F1EA] px-4 py-2.5">
      <span className="h-2.5 w-2.5 rounded-full bg-[#d8b4a0]" />
      <span className="h-2.5 w-2.5 rounded-full bg-[#e0cf9a]" />
      <span className="h-2.5 w-2.5 rounded-full bg-[#a9c3ac]" />
      <div className="ml-3 flex-1 truncate rounded-sm bg-white px-3 py-1 text-[11px] text-[#5C5855] border border-[#E8E4DB]">
        {url}
      </div>
    </div>
    <div className="h-[440px] overflow-hidden">{children}</div>
  </div>
);

export const PhoneFrame = ({ children, testid }) => (
  <div data-testid={testid} className="mx-auto w-[248px] rounded-[2rem] border-[6px] border-[#173A2C] bg-[#173A2C] shadow-[0_20px_60px_-25px_rgba(23,58,44,0.6)]">
    <div className="relative overflow-hidden rounded-[1.6rem] bg-[#FDFBF7]">
      <div className="absolute left-1/2 top-0 z-20 h-4 w-24 -translate-x-1/2 rounded-b-xl bg-[#173A2C]" />
      <div className="h-[500px] overflow-hidden">{children}</div>
    </div>
  </div>
);

// ---- Atoms ---------------------------------------------------------
export const Chip = ({ children, tone = "gold" }) => {
  const tones = {
    gold: "bg-[#C4A46B]/15 text-[#8a6f38] border-[#C4A46B]/40",
    green: "bg-[#2E6B4B]/12 text-[#2E6B4B] border-[#2E6B4B]/30",
    amber: "bg-[#D28E3D]/12 text-[#b0722a] border-[#D28E3D]/30",
    red: "bg-[#8B3A3A]/10 text-[#8B3A3A] border-[#8B3A3A]/25",
    slate: "bg-[#5C5855]/10 text-[#5C5855] border-[#5C5855]/20",
  };
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-medium tracking-wide ${tones[tone]}`}>
      {children}
    </span>
  );
};

export const Bar = ({ w = "w-full", h = "h-2", c = "bg-[#E8E4DB]" }) => (
  <div className={`${w} ${h} ${c} rounded-full`} />
);

export const SectionLabel = ({ children }) => (
  <div className="mb-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#C4A46B]">{children}</div>
);
